// extracted by mini-css-extract-plugin
export default {"forgotPassword":"account-info__forgotPassword__lPu6W","accountDeactivate":"account-info__accountDeactivate__UFeF2","supportDecorator":"account-info__supportDecorator__tPJj0"};